import { Box, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { darkGray } from '../../../../theme/color-constants';

interface HeaderFooterLayoutProps {
  title?: string;
  subtitle?: string;
  footer?: string;
}

export const HeaderFooterLayout = (
  props: PropsWithChildren<HeaderFooterLayoutProps>
) => {
  const { title, subtitle, footer, children } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      {(title || subtitle) && (
        <Box sx={{ flex: '0 0 auto', mb: 2 }}>
          {title && (
            <Typography variant="subtitle1" color="text.primary">
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" sx={{ color: darkGray }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      <Box sx={{ flex: '1 1 auto', minHeight: 0 }}>{children}</Box>
      {footer && (
        <Typography
          variant="caption"
          sx={{ flex: '0 0 auto', mt: 2, display: 'block', color: darkGray }}
        >
          {footer}
        </Typography>
      )}
    </Box>
  );
};
